module.exports = __webpack_public_path__ + "static/media/money-bags-badge.03dd7174.svg";